import notificationClient from '../../api/notificationClient';
import { Usage_Url, Product_Usage_Url, Quota_Invalidate_Url } from '../../api/endpoints';
import type { BackendAllUsageResponse, BackendProductUsageResponse } from '../../schema/notification';

/** Usage for every product in the platform catalog — backs the Quotas overview. */
export const getAllUsage = async (): Promise<BackendAllUsageResponse> => {
  const { data } = await notificationClient.get<BackendAllUsageResponse>(Usage_Url);
  return data;
};

export const getProductUsage = async (productId: string): Promise<BackendProductUsageResponse> => {
  const { data } = await notificationClient.get<BackendProductUsageResponse>(Product_Usage_Url(productId));
  return data;
};

export const invalidateCache = async (productId: string): Promise<void> => {
  await notificationClient.post(Quota_Invalidate_Url(productId));
};
